import _ from 'underscore';
import {adBuilderEnabled} from '@netx/core-ad-builder-next/enablers';
import {
	currentUserMeetsUserLevel,
	UserLevel,
} from '@netx/core-user-next/utils/currentUserMeetsUserLevel';

//===========================
// Underscore
//===========================
_.mixin({
	overrideDefaultIcon(path, override) {
		if (!path || (!path.includes('icons/') && !override)) return '';
		return (
			'custom-icon-' +
			_.toCamelCase(path.replace(/^\S+icons\//, '').replace(/\.\S+$/, ''))
		);
	},
});

//===========================
// !Underscore
//===========================

/**
 * @event netx:app:modules
 * @fires module:netx#netx:load:module
 * @fires module:app#app:ready
 */
dispatcher.once('netx:app:modules', function () {
	const toLoad = [
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-permissions'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-cart'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-asset'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-user'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-category'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-search'),
		import(/* webpackChunkName: "post-login-app" */ '@netx/core-share'),
	];
	if (adBuilderEnabled()) {
		toLoad.push(
			import(/* webpackChunkName: "post-login-app" */ '@netx/core-ad-builder'),
		);
	}

	Promise.all(toLoad).then((modules) => {
		dispatcher.trigger(
			'netx:load:module',
			modules.map((m) => m.default),
			{
				initialized() {
					dispatcher.trigger('app:ready', true);
				},
			},
		);
	});
});
